import React from 'react'
import {
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import { selectColor } from '../../../../function'
import { FONTS, COLORS } from '../../../../constants'

class ModalCompensateDetail extends React.PureComponent {
  render() {
    const events = get(this.props, 'events', [])
    return (
      /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ get(this.props, 'showCompensate') }
        toggle={ get(this.props, 'handleCompensateDetail') }
      >
        <ModalHeader toggle={ get(this.props, 'handleCompensateDetail') }>
          <Header>
            { get(this.props, 'flag') === 0 ? 'Compensate Work Request' : 'Holiday' }
          </Header>
        </ModalHeader>
        {
          get(this.props, 'flag') === 0 &&
            <ModalBody
              style={ { overflowY: 'auto', height: '500px' } }
            >
              <LabelText>Project</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'project') }</TextInfo>
                </Col>
              </Row>
              <LabelText>Approver</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'approver') }</TextInfo>
                </Col>
              </Row>
              <LabelText>Compenste Work Date</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>
                    {`${moment(get(events[0], 'start_date')).format('DD/MM/YYYY')} - ${moment(get(events[0], 'end_date')).format('DD/MM/YYYY')}`}
                  </TextInfo>
                </Col>
              </Row>
              <LabelText>Working Time</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'compensate_time') }</TextInfo>
                </Col>
              </Row>
              <LabelText>Total Compensate Work Day</LabelText>
              <Row noGutters>
                <Col>
                  <TextInfo>{ get(events[0], 'days') } days</TextInfo>
                </Col>
              </Row>
              {
                get(events[0], 'status') !== '' &&
                <div>
                  <LabelText>Status</LabelText>
                  <Row noGutters>
                    <Col>
                      <span style={ { color: selectColor(get(events[0], 'status')), fontWeight: 'bold' } }>
                        <TextInfo>{ get(events[0], 'status') }</TextInfo>
                      </span>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_request_user') !== '' &&
                <div>
                  <LabelText>Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_request_user') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_approver') !== '' &&
                <div>
                  <LabelText>Approver Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_approver') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events[0], 'remark_cancel') !== '' &&
                <div>
                  <LabelText>Cancel Remarks</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[0], 'remark_cancel') }</TextInfo>
                    </Col>
                  </Row>
                </div>
              }
              {
                get(events, 'length') > 1 &&
                <div>
                  <DropdownItem divider />
                  <LabelText>Project</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'project') }</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Approver</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'approver') }</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Compenste Work Date</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>
                        {`${moment(get(events[1], 'start_date')).format('DD/MM/YYYY')} - ${moment(get(events[1], 'end_date')).format('DD/MM/YYYY')}`}
                      </TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Working Time</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'compensate_time') }</TextInfo>
                    </Col>
                  </Row>
                  <LabelText>Total Compensate Work Day</LabelText>
                  <Row noGutters>
                    <Col>
                      <TextInfo>{ get(events[1], 'days') } days</TextInfo>
                    </Col>
                  </Row>
                  {
                    get(events[1], 'status') !== '' &&
                    <div>
                      <LabelText>Status</LabelText>
                      <Row noGutters>
                        <Col>
                          <span style={ { color: selectColor(get(events[1], 'status')), fontWeight: 'bold' } }>
                            <TextInfo>{ get(events[1], 'status') }</TextInfo>
                          </span>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_request_user') !== '' &&
                    <div>
                      <LabelText>Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_request_user') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_approver') !== '' &&
                    <div>
                      <LabelText>Approver Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_approver') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    get(events[1], 'remark_cancel') !== '' &&
                    <div>
                      <LabelText>Cancel Remarks</LabelText>
                      <Row noGutters>
                        <Col>
                          <TextInfo>{ get(events[1], 'remark_cancel') }</TextInfo>
                        </Col>
                      </Row>
                    </div>
                  }
                </div>
              }
            </ModalBody>
        }
        {
          get(this.props, 'flag') === 1 &&
            <ModalBody>
              <TextInfo>{ get(this.props, 'holiday_name') }</TextInfo>
            </ModalBody>
        }
      </Modal>
    )
  }
}

export default ModalCompensateDetail

// const Background = styled.div`
//   background-color: #F1F1F1;
//   padding-left: 10px;
//   font-family: ${FONTS.GOTHAM_MEDIUM} !important;
//   font-size: ${FONTS.NORMAL_SIZE};
// `
const LabelText = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`



// WEBPACK FOOTER //
// ./src/components/leave-request/compensate/modal-compensate-detail/index.js